module.exports = __webpack_public_path__ + "img/tuxsuite-build-set.bd9ef575.svg";